var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConcepts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87604 9.71814L6.75107 7.59314M10.3001 2.28064V1.21814M13.0904 3.38611L13.8417 2.63481M13.0904 9.00981L13.8417 9.76114M7.46674 3.38611L6.71544 2.63481M14.1959 6.17647H15.2584M4.01079 14.5834L10.5539 8.04038C10.8344 7.75988 10.9746 7.61956 11.0272 7.45785C11.0734 7.31561 11.0734 7.16233 11.0272 7.0201C10.9746 6.85835 10.8344 6.7181 10.5539 6.43759L10.0316 5.91536C9.75111 5.63485 9.61086 5.4946 9.44915 5.44204C9.30684 5.39582 9.15363 5.39582 9.01133 5.44204C8.84962 5.4946 8.70937 5.63485 8.42887 5.91536L1.88579 12.4584C1.60528 12.7389 1.46502 12.8792 1.41248 13.0409C1.36625 13.1832 1.36625 13.3364 1.41248 13.4787C1.46502 13.6404 1.60528 13.7807 1.88579 14.0612L2.40802 14.5834C2.68853 14.8639 2.82878 15.0042 2.99052 15.0567C3.13278 15.103 3.28603 15.103 3.42829 15.0567C3.59002 15.0042 3.73028 14.8639 4.01079 14.5834Z",
    stroke: "currentColor",
    strokeOpacity: 0.890196,
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcepts);
export default __webpack_public_path__ + "static/media/concepts.0056ca9dc33172d0e48828e36fa3be84.svg";
export { ForwardRef as ReactComponent };